/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2018 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  'use strict';

  // Use behaviors with context variable.
  Drupal.behaviors.siteHeader = {
    attach: function (context) {

      $(document).ready(function () {

        let $siteHeader = $('.site-header');
        let $menuHamburger = $('.site-header #pull');
        let $menuClose = $('.close-main-menu');
        let $searchTrigger = $('.site-header .search__open', context);
        let $searchClose = $('.close-search');
        let $searchTermInput = $('.site-search input[type="text"]');

        $menuHamburger.on('click', function (e) {
          e.preventDefault();
          $siteHeader.removeClass('search-open');
          $siteHeader.toggleClass('menu-open');
        });

        $menuClose.on('click', function (e) {
          e.preventDefault();
          $siteHeader.removeClass('menu-open');
          $menuHamburger.focus();
        });

        $(once('siteHeader', '.site-header .search__open', context)).on('click', function (e) {
          e.preventDefault();
          $siteHeader.removeClass('menu-open');
          $siteHeader.toggleClass('search-open');
          if ($siteHeader.hasClass('search-open')) {
            $searchTermInput.focus();
          }
        });

        $searchClose.on('click', function (e) {
          e.preventDefault();
          $siteHeader.removeClass('search-open');
          $searchTrigger.each(function (i, obj) {
            var visibility = $(this).css('visibility');
            if(visibility !== 'hidden') {
              $(this).focus();
            }
          });
        });

        // Close overlay and menus if a user presses `esc`
        $(document).keydown(function (e) {
          if (e.key === 'Escape' || e.key === 'Esc' || e.key === 27) {
            if ($siteHeader.hasClass('search-open')) {
              // Focus search trigger on `esc` press
              $searchTrigger.focus();
            }
            else if ($siteHeader.hasClass('menu-open')) {
              // Focus menu hamburger on `esc` press
              $menuHamburger.focus();
            }
            // Remove overlay classes on `esc` press
            $siteHeader.removeClass('menu-open search-open');
          }
        });

        ///////////////////////////////////////
        // This is for the styleguide ONLY
        ///////////////////////////////////////
        let $searchInput = $('.site-search form input[type="text"]');

        // display autocomplete block when user types in input
        $searchInput.keypress(function () {
          $(this).parents('form').addClass('form-search--autocomplete');
        });

        // hide autocomplete block when input is empty
        $searchInput.blur(function () {
          if ( !$(this).val() ) {
            $(this).parents('form').removeClass('form-search--autocomplete');
          }
        });

      });
    }
  };

})(jQuery);
